import React from "react";
import "./joinus.css";
import joinImg from "../../Media/joinus.jpg";
import { Link } from "react-router-dom";

const JoinUs = () => {
  return (
    <div className="joinus">
      <div className="joinus_left">
        <div>
          <h1>
            Join Us and become Amongst the first people to get help and relieved
            with DepRelief.
          </h1>

          <Link to="/start">
            <button>Get Started</button>
          </Link>
        </div>
      </div>
      <div className="joinus_right">
        <img src={joinImg} alt="joinus-img" />
      </div>
    </div>
  );
};

export default JoinUs;
